import React from 'react';
import {_Object} from "react-utils-y";
import {defaultPublic} from "../formStyle";

const inputSty = (_theme, _this) => {
    let publicSty = defaultPublic(_theme, _this);
    let sty = {
        inputBox: {
            padding: "0",
            margin: "0",
            width: "100%",
            border: "none",
            outline: "none",
            textOverflow: "ellipsis",
            color: `${_theme.publicForm.valueColor || '#666666'}`,
            fontWeight: "initial",
            fontFamily: "Microsoft YaHei",
            display: "block",
            height: "2rem",
            lineHeight: "2rem",
            wordBreak: "keep-all",
            overflow: "hidden",
            background: "rgba(0, 0, 0, 0)",
            paddingLeft: "0.625rem",
            paddingRight: "0.625rem",
            boxSizing: "border-box",
            textAlign: _this.props.valueAlign,
            fontSize: `${_theme.publicForm.textFontSize || ""}`,
        },
        inputBoxFocus: {
            padding: "0",
            margin: "0",
            width: "100%",
            border: "none",
            outline: "none",
            textOverflow: "ellipsis",
            color: `${_theme.publicForm.focusColor || '#666666'}`,
            fontWeight: "initial",
            fontFamily: "Microsoft YaHei",
            display: "block",
            height: "2rem",
            lineHeight: "2rem",
            wordBreak: "keep-all",
            overflow: "hidden",
            background: "rgba(0, 0, 0, 0)",
            paddingLeft: "0.625rem",
            paddingRight: "0.625rem",
            boxSizing: "border-box",
            textAlign: _this.props.valueAlign,
            fontSize: `${_theme.publicForm.textFontSize || ""}`,
        },
        //input禁用样式
        inputBoxDis: {
            width: "100%",
            textOverflow: "ellipsis",
            color: `${_theme.publicForm.disValueColor || '#000'}`,
            fontWeight: "initial",
            fontFamily: "Microsoft YaHei",
            display: "block",
            height: "2rem",
            lineHeight: "2rem",
            wordBreak: "keep-all",
            overflow: "hidden",
            paddingLeft: "0.625rem",
            paddingRight: "0.625rem",
            boxSizing: "border-box",
            textAlign: _this.props.valueAlign,
            fontSize: `${_theme.publicForm.textFontSize || ""}`,
        },
    };
    return _Object.merge(publicSty, sty)
};

export {
    inputSty,
};